
import Overlay from 'ol/Overlay';
import { randomString } from './uilt'
const overlayerIds = []
export function addChartsOverlay(dom, coodinate, positioning,layerIds, offset,) {
    let overlayerId = layerIds || `overlayer_${randomString()}_${new Date().getTime()}`
    const overlay = new Overlay({
        //要转换成overlay的HTML元素
        element: dom,
        id: overlayerId,
        offset: offset,
        //弹窗放置的位置
        positioning: positioning || 'center-center'
    });
    //设置弹窗的位置-ol方法
    overlay.setPosition(coodinate);
    //是否应该停止事件传播到地图窗口
    overlay.stopEvent = false
    // 添加信息框-sdk方法
    systemConfig.olApi.addOverlay(overlay);
    overlayerIds.push(overlayerId)
}
export function cleanChartsOverlayId(id) {
    // 移除指定信息框
    systemConfig.mapApi.removeOverlay(id)
}
export function cleanChartsOverlay() {
    for (const id in overlayerIds) {
        // 移除信息框
        systemConfig.mapApi.removeOverlay(id)
    }
}